

export interface MetalsLaserProgramSchedule{
    [MetalsLaserProgramScheduleShift.Day]: string[];
    [MetalsLaserProgramScheduleShift.Night]: string[];
}

export enum MetalsLaserProgramScheduleShift {
    Day = 'Day',
    Night = 'Night'
}

